import { action, thunk } from 'easy-peasy'

import { FetchStatus } from '@types'

import { FacilityModel, facilityService } from '.'

export const facility: FacilityModel = {
	paginator: {
		current_page: 1,
		next_page: 0,
		per_page: 10,
		previous_page: 0,
		total_items: 0,
		total_pages: 1
	},
	facilities: [],
	status: FetchStatus.LOADING,
	error: {},

	// Actions
	setPaginator: action((state, payload) => {
		state.paginator = payload
	}),
	setFacilities: action((state, payload) => {
		state.facilities = payload
	}),
	addFacilities: action((state, payload) => {
		state.facilities = [...state.facilities, ...payload]
	}),
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),

	// Thunks
	fetchAllFacilities: thunk((action, payload) => {
		action.setStatus(FetchStatus.LOADING)
		facilityService
			.getAllFacilities(payload)
			.then(({ data, paginator }) => {
				action.setPaginator(paginator)
				action.setFacilities(data)
				action.setStatus(FetchStatus.LOADED)
			})
			.catch(e => {
				action.setError(e)
				action.setStatus(FetchStatus.ERROR)
			})
	})
}
